// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__nJBhA","container":"style_container__lh2K+","textSpan":"style_textSpan__83sWz"};